import { createGlobalStyle } from "styled-components";

const Global = createGlobalStyle`

  html {
    background-color: white !important;
  }

  body {
    font-family: "TT Norms Pro", TTNormsPro, sans-serif;
    color: ${({ theme }) => theme.colors.fog["80"]};
    -webkit-font-smoothing: antialiased;
  }

  a[href]:not([tabindex='-1']),
  area[href]:not([tabindex='-1']),
  input:not([disabled]):not([tabindex='-1']),
  select:not([disabled]):not([tabindex='-1']),
  textarea:not([disabled]):not([tabindex='-1']),
  button:not([disabled]):not([tabindex='-1']),
  iframe:not([tabindex='-1']),
  [tabindex]:not([tabindex='-1']),
  [contentEditable=true]:not([tabindex='-1']) {
    :focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.dusk["50"]};
      outline-offset: 2px;
    }
  }

  button {
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.fog["80"]};
  }

  [data-tooltip-html] {
  border-bottom: 1px dashed #a7adb7;
}

[data-tooltip-html]:hover {
  cursor: pointer;
  opacity: 0.7;
}

  [data-disclosure-title] {
    position: relative;
    top: -0.25em;
    font-size: 0.6em;
    line-height: 1;
  }

  body > div[data-test-id=overlay-container] {
    z-index: 100;
  }
`;

export { Global };
